module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/products/products.component.scss
// module id = ./src/app/products/products.component.scss
// module chunks = main